import Login from 'views/Login';
import NotFoundScreen from 'views/NotFoundScreen';
import { StripeOnboardingRefresh } from 'views/StripeOnboarding/Refresh';
import { Welcome } from 'views/StripeOnboarding/Welcome';
import DashboardLayout from 'layouts/DashboardLayout';

import Pages from 'views/Pages';
import Dashboard from 'views/Dashboard';
import DonationDetail from 'views/PartnerDonationDetail';
import RecipientDonationDetail from 'views/RecipientDonationDetail';
import PagesDetail from 'views/Pages/PagesDetail';
import CommunityPagesDetail from 'views/CommunityPages/CommunityPagesDetail';
import { RecipientsList } from 'views/RecipientsList';
import { AdminsList } from 'views/Admins/AdminsList';
import { AdminsDetail } from 'views/Admins/AdminsDetail';
import { RecipientsDetail } from 'views/RecipientsDetail';
import { Payouts } from 'views/Payouts';
import { CommunityPages } from 'views/CommunityPages';
import { RecipientAdmins } from 'views/Settings/RecipientAdmins';
import ShoppingCart from 'views/ShoppingCart';
import { ShoppingCartDetail } from 'views/ShoppingCart/ShoppingCartDetail';
import Filters from 'views/Filters';
import FilterDetail from 'views/Filters/FilterDetail';

export const dashboardRoutes = [
  {
    path: 'dashboard',
    name: 'Dashboard',
    icon: 'Dashboard',
    element: <Dashboard />,
    permission: 'DASHBOARD_ROUTE',
  },
  {
    path: 'donation-list',
    name: 'Donation List',
    icon: 'List',
    element: <DonationDetail />,
    permission: 'DONATION_LIST_ROUTE',
  },
  {
    name: 'Pages',
    icon: 'Copy',
    collapse: true,
    permission: 'PAGES_ROUTE',
    state: 'pagesCollapse',
    children: [
      {
        path: 'donate_pages',
        name: 'Donate pages',
        element: <Pages category="donate" />,
        permission: 'DONATION_PAGES_ROUTE',
      },
      {
        path: 'event_pages',
        name: 'Event pages',
        element: <Pages category="event" />,
        permission: 'EVENT_PAGES_ROUTE',
      },
      {
        path: 'recommendation_pages',
        name: 'Recommendation pages',
        element: <Pages category="recommendation" />,
        permission: 'RECOMMENDATION_PAGES_ROUTE',
      },
      {
        path: 'community_pages',
        name: 'Community pages',
        element: <CommunityPages category="community" />,
        permission: 'COMMUNITY_PAGES_ROUTE',
      },
    ],
  },
  {
    path: 'pages_detail',
    redirect: true,
    element: <PagesDetail />,
    permission: 'PAGES_DETAIL_ROUTE',
  },
  {
    path: 'community_pages_detail',
    redirect: true,
    element: <CommunityPagesDetail />,
    permission: 'COMMUNITY_PAGES_DETAIL_ROUTE',
  },
  {
    path: 'recipients',
    name: 'Recipients',
    icon: 'UserPlus',
    element: <RecipientsList />,
    permission: 'RECIPIENTS_ROUTE',
  },
  {
    path: 'recipients_detail',
    redirect: true,
    element: <RecipientsDetail />,
    permission: 'RECIPIENTS_DETAIL_ROUTE',
  },
  {
    path: 'admins',
    name: 'Admins',
    icon: 'PlusSquare',
    element: <AdminsList />,
    permission: 'ADMINS_ROUTE',
  },
  {
    path: 'admins_detail',
    redirect: true,
    element: <AdminsDetail />,
    permission: 'ADMINS_DETAIL_ROUTE',
  },
  {
    path: 'recipient-donation-list',
    name: 'Donation List',
    icon: 'List',
    element: <RecipientDonationDetail />,
    permission: 'RECIPIENTS_DONATION_LIST_ROUTE',
  },
  {
    name: 'Reports',
    path: 'payouts',
    icon: 'PlusSquare',
    element: <Payouts />,
    permission: 'PAYOUTS_ROUTE',
  },
  {
    name: 'Settings',
    icon: 'Cog',
    collapse: true,
    permission: 'SETTINGS_ROUTE',
    state: 'settingsCollapse',
    children: [
      {
        path: 'settings_admins',
        name: 'Admins',
        element: <RecipientAdmins />,
        permission: 'SETTINGS_RECIPIENT_ADMINS_ROUTE',
      },
    ],
  },
  {
    name: 'Configurations',
    icon: 'Cog',
    collapse: true,
    permission: 'SHOPPING_CART_ROUTE',
    state: 'configurationsCollapse',
    children: [
      {
        path: 'shopping_cart',
        name: 'Shopping Cart',
        element: <ShoppingCart />,
        permission: 'SHOPPING_CART_ROUTE',
      },
      {
        path: 'filters',
        name: 'Filters',
        element: <Filters />,
        permission: 'FILTERS_ROUTE',
      },
    ],
  },
  {
    path: 'shopping_cart_detail',
    redirect: true,
    element: <ShoppingCartDetail />,
    permission: 'SHOPPING_CART_DETAIL_ROUTE',
  },
  {
    path: 'filters_detail',
    redirect: true,
    element: <FilterDetail />,
    permission: 'FILTERS_DETAIL_ROUTE',
  },
];

const routes = [
  // Public routes (no layout)
  {
    path: '/',
    name: 'Login',
    element: <Login />,
    errorElement: <NotFoundScreen />,
  },
  {
    path: '/welcome',
    element: <Welcome />,
  },
  {
    path: '/stripe-onboarding-refresh',
    element: <StripeOnboardingRefresh />,
  },
  // Protected routes (with layout)
  {
    path: '/',
    element: <DashboardLayout />,
    errorElement: <NotFoundScreen />,
    children: dashboardRoutes,
  },
];

export default routes;
